import React from 'react';
import { Stack, Typography, Chip, SxProps, Theme } from '@mui/material';

interface LabeledChipProps {
    label: string;
    value: string | string[];
    variant?: 'outlined' | 'filled';
    sx?: SxProps<Theme>;
}

/**
 * A common component to display a label with chip value(s).
 *
 * @param {LabeledChipProps} props
 * @returns {JSX.Element}
 */
const LabeledChip: React.FC<LabeledChipProps> = ({ label, value, variant = 'outlined', sx }) => {
    const values = Array.isArray(value) ? value : [value];

    return (
        <Stack direction="row" spacing={0.5} flexWrap="wrap" alignItems="center" sx={sx}>
            <Typography variant="body2">{label}</Typography>
            <Stack direction="row" spacing={0.5} flexWrap="wrap">
                {values.map((val, index) => (
                    <Chip key={index} size="small" variant={variant} label={val} />
                ))}
            </Stack>
        </Stack>
    );
};

export default LabeledChip;
